export default "__VITE_ASSET__DFnvQiC3__"